import { render, staticRenderFns } from "./btn-color-scheme.vue?vue&type=template&id=6c0dbc92&scoped=true"
import script from "./btn-color-scheme.vue?vue&type=script&lang=js"
export * from "./btn-color-scheme.vue?vue&type=script&lang=js"
import style0 from "./btn-color-scheme.vue?vue&type=style&index=0&id=6c0dbc92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0dbc92",
  null
  
)

export default component.exports